<div class="cc" [class.cc--invalid]="!isValid()" [class]="'cc--' + meta().category">
  <!-- Category indicator bar (left edge) -->
  <div class="cc-indicator"></div>

  <!-- Card content -->
  <div class="cc-body">
    <!-- Header: icon + label + remove -->
    <div class="cc-header">
      <mat-icon class="cc-type-icon">{{ meta().icon }}</mat-icon>
      <span class="cc-type-label">{{ meta().labelKey | transloco }}</span>
      <button mat-icon-button
              class="cc-remove"
              (click)="remove.emit()"
              [attr.aria-label]="'Remove constraint'">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Inline Editor (type-specific) -->
    <div class="cc-editor">
      @switch (constraint().type) {
        <!-- ── BPN Numbers ── -->
        @case (PolicyType.PARTICIPANT_RESTRICTED) {
          <div class="cc-chips-editor">
            <mat-chip-grid #chipGrid>
              @for (bpn of bpnChips(); track bpn) {
                <mat-chip-row (removed)="removeBpn(bpn)">
                  {{ bpn }}
                  <button matChipRemove aria-label="Remove">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <mat-form-field appearance="outline" class="cc-chip-input">
              <input matInput
                     [formControl]="bpnInput"
                     [matChipInputFor]="chipGrid"
                     [placeholder]="'policyBuilder.editor.bpnPlaceholder' | transloco"
                     (keydown)="onBpnKeydown($event)"
                     (blur)="addBpn()" />
            </mat-form-field>
          </div>
        }

        <!-- ── Membership (no editor needed) ── -->
        @case (PolicyType.MEMBERSHIP_STATIC) {
          <p class="cc-static-text">{{ 'policyBuilder.editor.membershipInfo' | transloco }}</p>
        }

        <!-- ── Framework Agreement (no editor needed) ── -->
        @case (PolicyType.FRAMEWORK_AGREEMENT) {
          <p class="cc-static-text">{{ 'policyBuilder.editor.frameworkAgreementInfo' | transloco }}</p>
        }

        <!-- ── Use Case ── -->
        @case (PolicyType.USE_CASE_MEMBERSHIP) {
          <mat-form-field appearance="outline" class="cc-field">
            <mat-label>{{ 'policyBuilder.editor.useCaseLabel' | transloco }}</mat-label>
            <mat-select [formControl]="useCaseCtrl">
              @for (opt of useCaseOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- ── Duration (Days) ── -->
        @case (PolicyType.TIME_PERIOD_RESTRICTED) {
          <mat-form-field appearance="outline" class="cc-field">
            <mat-label>{{ 'policyBuilder.editor.durationLabel' | transloco }}</mat-label>
            <input matInput type="number" [formControl]="countCtrl" min="1" />
            <span matTextSuffix class="cc-suffix">{{ 'policyBuilder.editor.durationSuffix' | transloco }}</span>
          </mat-form-field>
        }

        <!-- ── End Date ── -->
        @case (PolicyType.END_DATE) {
          <mat-form-field appearance="outline" class="cc-field">
            <mat-label>{{ 'policyBuilder.editor.endDateLabel' | transloco }}</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="endDateCtrl" [min]="minDate" />
            <mat-datepicker-toggle matIconSuffix [for]="picker" />
            <mat-datepicker #picker />
          </mat-form-field>
        }

        <!-- ── Company Region ── -->
        @case (PolicyType.COMPANY_REGION_RESTRICTED) {
          <mat-form-field appearance="outline" class="cc-field">
            <mat-label>{{ 'policyBuilder.editor.companyRegionLabel' | transloco }}</mat-label>
            <mat-select [formControl]="regionCtrl">
              @for (opt of regionOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- ── Datacenter Region ── -->
        @case (PolicyType.DATACENTER_REGION_RESTRICTED) {
          <mat-form-field appearance="outline" class="cc-field">
            <mat-label>{{ 'policyBuilder.editor.datacenterRegionLabel' | transloco }}</mat-label>
            <mat-select [formControl]="regionCtrl">
              @for (opt of regionOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label | transloco }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>
  </div>
</div>
